import { Route } from 'react-router';
import { getRedirectAppPoolUrl } from '../modules/common';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            localStorage.getItem('DMS_APPLICATION') ? (
                <Component {...props} />
            ) : (
                <>{getRedirectAppPoolUrl()}</>
            )
        }
    />
);
